import { GET_INSTAGRAM_ACCOUNT_ANALYTICS_SUCCESS, GET_INSTAGRAM_ACCOUNT_ANALYTICS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { accounts: [], errors: null };

export default function instagramAccountsAnalytics(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case GET_INSTAGRAM_ACCOUNT_ANALYTICS_SUCCESS:
      return { ...state, accounts: action.payload.data, errors: null }
    case GET_INSTAGRAM_ACCOUNT_ANALYTICS_FAILURE:
      return { ...state, accounts: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
